import React from 'react'

function SalesInvoiceDetailsReport() {
  return (
    <div>SalesInvoiceDetailsReport</div>
  )
}

export default SalesInvoiceDetailsReport